import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import type { TopicAction } from '@stores/topic/action';
import type { ActivityAction } from '@stores/activity/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import ThreadList from '@components/threadList';
import UserList from '@components/userList';
import TopicList from '@components/topicList';
import ActivityList from '@components/activityList';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarCherryPickList from '@components/sidebarCherryPickList';
import Avatar from '@components/avatar';
import { CommonAction } from '@stores/common/action';
import TabNav from '@components/tabNav';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import { formatDateTime } from '@utils/timeUtils'; // 相对路径
import { formatNumberToWan } from '@utils/formatNumber';
import { highlightname } from '@utils/high-light-name';

interface SearchPCPageProps extends BasePageProps, RouteComponentProps {
    namespace?: any
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    topic?: TopicAction;
    activity?: ActivityAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    userInfo?: any;
    common?: CommonAction;
    searchValue?: any
    navList?: any
    navClick?: Function
    navCurrentIndex?: any
    searchTopicList?: any
    topicTotalCount?: any // 搜索到的话题总数
    searchUserList?: any
    userTotalCount?: any // 搜索到的用户总数
    createFollowUser?: any  // 关注用户事件
    followDelete?: any  // 取消关注用户事件
    searchActivityList?: any
    activityTotalCount?: any // 搜索到的活动总数
    searchThreadList?: any
    threadTotalCount?: any // 搜索到的帖子总数
}
interface SearchPCPageState {
    loading: boolean;
    error: any
    pageLoaded: any
}

@inject('app', 'site', 'user', 'thread', 'common')
@observer
class SearchPCPage extends BasePage<SearchPCPageProps, SearchPCPageState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        
    }

    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        console.log('导航点击:', { item, index });
        
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }

    // 帖子列表
    renderThreadList = () => {
        const { loading, hasMore, onLoadMore, namespace, searchValue } = this.props;
        const { thread } = this.props;
        // 获取列表数据和状态
        const listStore = thread?.listStore;
        const list = listStore?.lists[namespace];
        const searchThreadList = listStore?.getList({ namespace: 'searchThreadList' }) || [];
        // console.log(listStore, '命名空间11');
        // console.log('[PC] loading:', loading);
        // console.log('[PC] hasMore:', hasMore);
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList data={searchThreadList} namespace={namespace} emptyText='未搜索到相关帖子' emptyIcon={`${BASE_IMG_URL}/common/null4.png`} emptyBoxStyle={{ padding: '200px 0 500px' }} loading={loading} hasMore={hasMore} searchKeyword={searchValue} onLoadMore={() => onLoadMore()}></ThreadList>
                {/* {loading && <div className={styles.loading}>加载中...</div>}
                {!hasMore && !loading && <div className={styles.loading}>没有更多了</div>} */}
            </div>
        )
    }
    // 用户item
    renderUserItem = (item) => {
        let {searchValue} = this.props;
        return (
            <div className={styles.userItem}
                onClickCapture={(e) => {
                // 在捕获阶段阻止事件
                if (e.target === e.currentTarget) {
                //   console.log('点击了父组件区域（不包括子组件）');
                } else {
                  e.stopPropagation(); // 阻止事件传播到子组件
                  window.open(`/user/${item.code}`);
                //   console.log('阻止了子组件的点击');
                }
              }}>
                <Avatar
                    avatarUrl={item.avatar}
                    titleMark={item.titleMark}
                    userCode={item.code}
                    size={50}
                    officialSize={20}
                ></Avatar>
                <div 
                    className={styles.username}
                    dangerouslySetInnerHTML={{ 
                        __html: highlightname(item.nickname, searchValue) || '用户名'
                    }}
                />
            </div>
        )
    }

    // 活动item
    renderActivityItem = (item) => {
        let {searchValue} = this.props;
        // 根据状态获取按钮文本
        const getButtonText = (item: any) => {
            // status: 0 未开始 1 进行中 2 已结束
            if (item.status === 2) {
                // 已结束
                return '查看活动';
            } else if (item.status === 1 || item.status === 0) {
                // 进行中或未开始
                return item.thread?.hasForm ? '立即报名' : '立即参与';
            }
            return '';
        };

        // 获取状态文本
        const getStatusText = (status: number) => {
            const statusMap: { [key: number]: string } = {
                0: '未开始',
                1: '进行中',
                2: '已结束'
            };
            return statusMap[status] || '';
        };

        // 判断是否进行中（用于样式）
        const isInProgress = (status: number) => status === 1;
        const buttonText = getButtonText(item);
        const statusText = getStatusText(item.status);
        const inProgress = isInProgress(item.status);
        const isEnded = item.status === 2;
        return (
            <div key={item.id} className={styles.activityItem} onClick={()=>{
                // this.props.history.push('/threadDetail/' + item.threadId);
                window.open(`/threadDetail/${item.threadId}`);
            }}>
                <img src={item.coverUrl} alt={item.thread?.title} className={styles.activityCover} />
                <div className={styles.activityTitleBox}>
                    <div className={classNames(styles.statusBox, inProgress ? styles.progressStatus : styles.endStatus)}>
                        <img src={inProgress ? `${BASE_IMG_URL}/common/status1.png` : `${BASE_IMG_URL}/common/status2.png`} alt="" className={styles.statusIcon} />
                        <div className={styles.statusText}>{statusText}</div>
                    </div>
                    {/* <div className={styles.activityTitle} style={{ color: isEnded ? '#A7A9AC' : '' }}>{highlightname(item.thread?.title, searchValue)}</div> */}
                    <div className={styles.activityTitle} style={{ color: isEnded ? '#A7A9AC' : '' }}
                        dangerouslySetInnerHTML={{ 
                            __html: highlightname(item.thread?.title, searchValue) || '活动标题'
                        }}
                    />
                </div>
                <div className={styles.activityInfo}>
                    <div className={styles.activityTime}>{formatDateTime(item.endAt)}</div>
                    <div className={styles.postCount}>{formatNumberToWan(item.discussionCount)}讨论量</div>
                    {isEnded ? (
                        <div className={styles.statusBtn2}>{buttonText}</div>
                    ) : (
                        <div className={styles.statusBtn}>{buttonText}</div>
                    )}
                </div>
            </div>
        )
    }

    // 首页左侧侧内容
    readerLeft = () => {
        let { topic, user, activity, thread, searchValue, navList, navCurrentIndex, searchTopicList, topicTotalCount, searchUserList, userTotalCount, createFollowUser, followDelete, searchActivityList, activityTotalCount, searchThreadList, threadTotalCount, loading, hasMore, onLoadMore } = this.props;
        // console.log('话题数据',searchTopicList);
        // console.log(searchActivityList, '活动数据----111---', loading, hasMore, onLoadMore);

        return (
            <div className={styles.leftContent}>
                <div className={styles.navListBox}>
                    <TabNav navList={navList} isAlignLeft={true} currentIndex={navCurrentIndex} navClick={(item:any, index:any) => this.handleNavClick(item, index)}></TabNav>
                </div>
                
                {/* 综合 */}
                {navCurrentIndex == 0 && <>
                    {/* 综合-话题（最多3个） */}
                    {searchTopicList?.length > 0 && <div className={styles.searchResultItem}>
                        <div className={styles.resultItemTitleBox}>
                            <div className={styles.title}>话题<span>({topicTotalCount})</span></div>
                            <div className={styles.more} onClick={() => this.handleNavClick('', 1)}></div>
                        </div>
                        <div className={styles.resultListBox}>
                            <TopicList topicList={searchTopicList} searchKeyword={searchValue} ></TopicList>
                        </div>
                    </div>}
                    {/* 综合-用户（最多8个） */}
                    {searchUserList?.length > 0 && <div className={styles.searchResultItem}>
                        <div className={styles.resultItemTitleBox}>
                            <div className={styles.title}>用户<span>({userTotalCount})</span></div>
                            <div className={styles.more} onClick={() => this.handleNavClick('', 2)}></div>
                        </div>

                        <div className={classNames(styles.resultListBox, styles.resultUserList)}>
                            {searchUserList.map((item: any) => (<>
                                {this.renderUserItem(item)} 
                            </>))}
                            {/* <UserList userList={searchUserList} searchKeyword={searchValue} createFollowUserCallBack={createFollowUser} followDeleteCallBack={followDelete}></UserList> */}
                        </div>
                    </div>}
                    {/* 综合-活动（最多2个） */}
                    {searchActivityList?.length > 0 && <div className={styles.searchResultItem}>
                        <div className={styles.resultItemTitleBox}>
                            <div className={styles.title}>活动<span>({activityTotalCount})</span></div>
                            <div className={styles.more} onClick={() => this.handleNavClick('', 3)}></div>
                        </div>
                        <div className={classNames(styles.resultListBox, styles.activityListBox)}>
                            {searchActivityList.map((item: any) => (<>
                                {this.renderActivityItem(item)} 
                            </>))}
                        </div>
                    </div>}
                    {/* 综合-帖子（最多5个） */}
                    {searchThreadList?.length > 0 && <div className={styles.searchResultItemBox}>
                        <div className={styles.resultItemTitleBox} style={{marginBottom: '12px'}}>
                            <div className={styles.title}>帖子<span>({threadTotalCount})</span></div>
                            <div className={styles.more} onClick={() => this.handleNavClick('', 4)}></div>
                        </div>
                        <div className={classNames(styles.resultListBox)} style={{paddingTop: 0}}>
                            {this.renderThreadList()}
                        </div>
                    </div>}
                    {/* 当未搜索到任何内容时 */}
                    {(topicTotalCount == 0 && userTotalCount == 0 && activityTotalCount == 0 && threadTotalCount == 0) && <div className={styles.nullBox}>
                        <img src={`${BASE_IMG_URL}/common/null4.png`} alt="" className={styles.nullIcon} />
                        <div className={styles.nullText}>未搜索到相关内容</div>
                    </div>}
                </>}

                {/* 话题 */}
                {navCurrentIndex == 1 && <div className={styles.singleResultBox}>
                    {topicTotalCount > 0 && <div className={styles.singleResultTitle}>搜索到话题<span>({topicTotalCount})</span></div>}
                    <TopicList topicList={searchTopicList} emptyText='未搜索到相关话题' emptyIcon={`${BASE_IMG_URL}/common/null4.png`} emptyBoxStyle={{ padding: '200px 0 500px' }} searchKeyword={searchValue} loading={loading} hasMore={hasMore} onLoadMore={() => onLoadMore()}></TopicList>
                </div>}
                
                {/* 用户 */}
                {navCurrentIndex == 2 && <div className={styles.singleResultBox}>
                    {userTotalCount > 0 && <div className={styles.singleResultTitle}>搜索到用户<span>({userTotalCount})</span></div>}
                    <UserList userList={searchUserList} emptyText='未搜索到相关用户' emptyIcon={`${BASE_IMG_URL}/common/null4.png`} emptyBoxStyle={{ padding: '200px 0 500px' }} searchKeyword={searchValue} createFollowUserCallBack={createFollowUser} followDeleteCallBack={followDelete} loading={loading} hasMore={hasMore} onLoadMore={() => onLoadMore()}></UserList>
                </div>}

                {/* 活动 */}
                {navCurrentIndex == 3 && <div className={styles.singleResultBox}>
                    {activityTotalCount > 0 && <div className={styles.singleResultTitle}>搜索到活动<span>({activityTotalCount})</span></div>}
                    <ActivityList data={searchActivityList} isLeftSize={true} emptyText='未搜索到相关活动' emptyIcon={`${BASE_IMG_URL}/common/null4.png`} emptyBoxStyle={{ padding: '200px 0 500px' }} searchKeyword={searchValue} loading={loading} hasMore={hasMore} onLoadMore={() => onLoadMore()}></ActivityList>
                </div>}

                {/* 帖子 */}
                {navCurrentIndex == 4 && <div className={styles.singleResultBox}>
                    {threadTotalCount > 0 && <div className={styles.singleResultTitle}>搜索到帖子<span>({threadTotalCount})</span></div>}
                    {this.renderThreadList()}
                </div>}
            </div>
        );
    }

    // 首页右侧内容
    readerRight = () => {
        // let { topicList } = this.state;
        // let isLogin = false;
        return (
            <div className={styles.rightContent}>
                {/* 用户信息 */}
                {/* <SidebarUserInfo></SidebarUserInfo> */}
                {/* 下载app */}
                {/* <DownloadApp></DownloadApp> */}

                {/* 精选帖子列表 */}
                <SidebarCherryPickList></SidebarCherryPickList>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>
                
            </div>
        );
    }

    render() {
        const { app } = this.props;

        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (<div className={styles.wrapper}>
                {this.readerLeft()}
                {this.readerRight()}
            </div>)
        }

    }
}

export default withRouter(SearchPCPage);
